export const __DEV__ = process.env.REACT_APP_ENV_MODE === 1;
export const ApiUrl = process.env.REACT_APP_API_URL;
export const GoogleAuth = '/user/googleauth';
export const FacebookAuth = '/user/facebookauth';
export const AWSS3Url = 'https://depotexpress-orders.s3.ca-central-1.amazonaws.com/' + process.env.REACT_APP_ENV_MODE;